/*
 * ta-carousel — Swiper-backed mobile carousels.
 *
 * Any element with `.ta-swiper` (and the standard `.swiper > .swiper-wrapper >
 * .swiper-slide` structure inside) becomes a Swiper slider on mobile only.
 * On larger screens the slider is destroyed so the original desktop layout
 * (driven entirely by CSS) renders unchanged.
 *
 * Per-element config via data attributes:
 *   data-swiper-per-view="1.6"   slides visible at once (fractional = peek)
 *   data-swiper-gap="10"         space between slides in px
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var mql = window.matchMedia(MOBILE);
  var instances = new Map();

  function options(el) {
    var opts = {
      slidesPerView: parseFloat(el.getAttribute('data-swiper-per-view')) || 1.1,
      spaceBetween: parseInt(el.getAttribute('data-swiper-gap'), 10) || 12,
      grabCursor: true,
      // Only capture mostly-horizontal gestures; vertical swipes scroll the
      // page. This is what fixes the scroll being "trapped" on the carousel.
      touchAngle: 40,
      threshold: 4,
      touchReleaseOnEdges: true,
      resistanceRatio: 0.7
    };

    // Opt-in controls: only enable for carousels that ship the markup for them.
    var pagination = el.querySelector('.swiper-pagination');
    if (pagination) opts.pagination = { el: pagination, clickable: true };

    var prev = el.querySelector('.swiper-button-prev');
    var next = el.querySelector('.swiper-button-next');
    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };

    return opts;
  }

  // The reveal system hides [data-reveal] elements until they intersect the
  // viewport. Inside a Swiper, off-screen slides may never intersect, so force
  // them visible while the slider is active (inline styles beat the .is-in rule).
  function unhide(el) {
    el.querySelectorAll('[data-reveal]').forEach(function (node) {
      node.style.opacity = '1';
      node.style.transform = 'none';
    });
  }

  function rehide(el) {
    el.querySelectorAll('[data-reveal]').forEach(function (node) {
      node.style.opacity = '';
      node.style.transform = '';
    });
  }

  function enable() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.ta-swiper').forEach(function (el) {
      if (instances.has(el)) return;
      unhide(el);
      instances.set(el, new Swiper(el, options(el)));
    });
  }

  function disable() {
    instances.forEach(function (swiper, el) {
      swiper.destroy(true, true);
      rehide(el);
      instances.delete(el);
    });
  }

  function sync() {
    if (mql.matches) enable();
    else disable();
  }

  function start() {
    sync();
    if (mql.addEventListener) mql.addEventListener('change', sync);
    else mql.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-init when the Shopify theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function () {
    if (mql.matches) window.setTimeout(enable, 0);
  });
})();
